/**
 * Ant Design Slider component tokens mapped to Vitamin Play semantic CSS variables.
 * Copied from internal-apps-react-antd (PR #10) as a runtime overlay until
 * @vtmn-play/antd ships the slider mapping.
 * @see https://ant.design/components/slider#design-token
 */
export const SLIDER_TOKENS = {
  controlSize: '--vp-semantic-sizing-s',
  dotActiveBorderColor: '--vp-semantic-color-border-brand',
  dotBorderColor: '--vp-semantic-color-border-neutral',
  dotSize: '--vp-semantic-sizing-xs',
  handleActiveColor: '--vp-semantic-color-border-brand',
  handleActiveOutlineColor: '--vp-semantic-color-alpha-brand-l',
  handleColor: '--vp-semantic-color-border-brand',
  handleColorDisabled: '--vp-semantic-color-border-neutral',
  handleLineWidth: '--vp-semantic-border-width-m',
  handleLineWidthHover: '--vp-semantic-border-width-m',
  handleSize: '--vp-semantic-sizing-s',
  handleSizeHover: '--vp-semantic-sizing-m',
  railBg: '--vp-semantic-color-border-quiet',
  railHoverBg: '--vp-semantic-color-border-neutral',
  railSize: '--vp-semantic-sizing-2xs',
  trackBg: '--vp-semantic-color-border-brand',
  trackBgDisabled: '--vp-semantic-color-border-neutral',
  trackHoverBg: '--vp-semantic-color-border-brand'
}

const PX_TOKEN_HINTS = ['radius', 'sizing', 'spacing', 'font-size', 'border-width']

const getCssValue = (token: string) => getComputedStyle(document.documentElement).getPropertyValue(token).trim()

const getPxValue = (token: string) => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return 0
  }
  return Number.parseInt(getCssValue(token).replace('px', ''), 10)
}

export const buildAntTokenCssValuesMap = (tokens: Record<string, string>) =>
  Object.entries(tokens).reduce(
    (acc, [key, value]) => {
      const isPxToken = PX_TOKEN_HINTS.some(hint => value.includes(hint))
      acc[key] = isPxToken ? getPxValue(value) : getCssValue(value)
      return acc
    },
    {} as Record<string, string | number>
  )
